var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmilyFace(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 86,
    viewBox: "0 0 97 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97 43C97 66.748 77.748 86 54 86C43 86 43 86 43 86V0H54C77.748 0 97 19.252 97 43Z",
    fill: "#D2D3D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8311 53C91.3235 71.9254 74.3052 86 54 86H43V53H95.8311Z",
    fill: "#B5B8BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86 43C86 66.748 66.748 86 43 86C19.252 86 0 66.748 0 43C0 19.252 19.252 0 43 0C66.748 0 86 19.252 86 43Z",
    fill: "#EDEEF0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75 43C75 60.673 60.673 75 43 75C25.327 75 11 60.673 11 43C11 25.327 25.327 11 43 11C60.673 11 75 25.327 75 43Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 43C29 44.105 28.105 45 27 45C25.895 45 25 44.105 25 43C25 41.895 25.895 41 27 41C28.105 41 29 41.895 29 43Z",
    fill: "#B5B8BD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61 43C61 44.105 60.105 45 59 45C57.895 45 57 44.105 57 43C57 41.895 57.895 41 59 41C60.105 41 61 41.895 61 43Z",
    fill: "#B5B8BD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47 50L47.7071 50.7071C48.0976 50.3166 48.0976 49.6834 47.7071 49.2929C47.3174 48.9032 46.6861 48.9024 46.2954 49.2904L46.2935 49.2923L46.2928 49.2929C46.2891 49.2965 46.2818 49.3036 46.2709 49.3137C46.2493 49.3339 46.2138 49.3664 46.1654 49.4084C46.0683 49.4925 45.921 49.6132 45.7313 49.7488C45.3478 50.0227 44.8121 50.3419 44.1838 50.5513C43.5596 50.7594 42.864 50.853 42.1336 50.7069C41.4106 50.5623 40.5834 50.1692 39.7071 49.2929C39.3166 48.9024 38.6834 48.9024 38.2929 49.2929C37.9024 49.6834 37.9024 50.3166 38.2929 50.7071C39.4166 51.8309 40.5894 52.4377 41.7414 52.6681C42.886 52.897 43.9404 52.7406 44.8162 52.4487C45.6879 52.1581 46.4022 51.7273 46.8937 51.3762C47.1415 51.1993 47.3379 51.0388 47.4752 50.9198C47.544 50.8601 47.5984 50.8106 47.6373 50.7742C47.6567 50.756 47.6723 50.7411 47.684 50.7298L47.6986 50.7156L47.7036 50.7106L47.7055 50.7087L47.7064 50.7079C47.7067 50.7075 47.7071 50.7071 47 50Z",
    fill: "#B5B8BD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7998 10.207C26.214 10.9245 25.9682 11.8419 25.2507 12.2561C19.854 15.3719 15.3726 19.8533 12.2568 25.25C11.8426 25.9674 10.9252 26.2132 10.2078 25.799C9.49034 25.3848 9.24453 24.4674 9.65874 23.75C13.0378 17.8972 17.898 13.0371 23.7507 9.658C24.4682 9.24379 25.3855 9.4896 25.7998 10.207Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.30953 27.6327C10.0766 27.9457 10.4447 28.8212 10.1317 29.5882L10.079 29.7181C9.76901 30.4864 8.89495 30.8579 8.12669 30.548C7.35843 30.238 6.98689 29.364 7.29684 28.5957C7.3158 28.5487 7.33486 28.5017 7.35401 28.4548C7.66698 27.6878 8.5425 27.3197 9.30953 27.6327Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmilyFace);
export default __webpack_public_path__ + "static/media/smily-face.8d1b33e1.svg";
export { ForwardRef as ReactComponent };